import { Editor } from 'codemirror';
import React, { useEffect, useRef } from 'react';

import { RobotCodeLoadable } from '../__code/robot__code-loadable';
import { useRobotSelector } from '../context';

export const RobotBlocklyCode = () => {
    const editorRef = useRef<Editor>();
    const code = useRobotSelector((s) => s.codeString);
    const initialValue = useRef(code);
    useEffect(() => {
        editorRef.current?.setValue(code);
    }, [code]);

    return (
        <RobotCodeLoadable
            editorRef={editorRef}
            initialValue={initialValue.current}
            lineNumber={useRobotSelector((s) => s.state.lineNumber)}
            options={{ readOnly: true }}
        />
    );
};
